import { useMutation, useQueryClient } from 'react-query';
import request from '../../../../../helpers/request';
import { queryKeysShutdowns } from '../../constants/queryKeys';

const onSaveFilter = async (data) => {
  const { id, ...dataCreate } = data;

  if (!!id) {
    return await request.put(
      '/Filter',
      data,
      'При сохранении фильтра произошла ошибка',
      'Error'
    );
  }

  return await request.post(
    '/Filter',
    dataCreate,
    'При сохранении фильтра произошла ошибка',
    'Error'
  );
};

const useSaveFilter = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(onSaveFilter, {
    onSuccess: (data) => {
      if (data === 'Error') return;

      queryClient.invalidateQueries(queryKeysShutdowns.savedFilters());
    },
  });

  return {
    isSaveFilterLoading: mutation.isLoading,
    onSaveFilter: mutation.mutateAsync,
  };
};

export default useSaveFilter;
